import { getAttributeFromElement } from '../../node-utils';
import { DATA_MODAL_TYPE, STEP_MODAL, DEFAULT_MODAL } from './constants';

const myModal = window.bootbox;

// Get current content of step modal
export function createStepContent(totalSteps, currentStep, bodies, footers) {
  const currentContent = bodies.get(currentStep).outerHTML;
  const currentFooter = selectStepFooter(currentStep, totalSteps, footers)
    .outerHTML;
  // Join html elements
  return currentContent + currentFooter;
}

/**
 * Select the correct content depend on currenStep
 * @param {*} currentStep
 * @param {*} totalSteps
 * @param {*} footers
 */
export function selectStepFooter(currentStep, totalSteps, footers) {
  switch (totalSteps - currentStep) {
    case totalSteps:
      return footers.get(0);
    case 1:
      return footers.get(2);
    default:
      return footers.get(1);
  }
}

export function refreshContent(totalSteps, currentStep, content) {
  $('.bootbox-body').html(content);
}

function getModalType($modal) {
  return getAttributeFromElement($modal, DATA_MODAL_TYPE);
}

export function isStepModal($modal) {
  return getModalType($modal) === STEP_MODAL;
}

export function isDefaultModal($modal) {
  return getModalType($modal) === DEFAULT_MODAL;
}

export function createDialogInstance(opts) {
  const dialogOpts = {
    ...opts,
    className: 'text-center wc-modal',
  };

  if (opts.classes) {
    dialogOpts.className += ' ' + opts.classes.replace('hidden', '');
  }

  return myModal.dialog(dialogOpts);
}

/**
 * Only close current modal
 * @param {*} modalInstance
 */
export function hideModal(modalInstance) {
  modalInstance.modal('hide');
}
/**
 * Close all modals
 */
export function closeAllModals() {
  myModal.hideAll();
}

export function addCloseEventIntoDialog($dialog) {
  $('[role="modal-close"]', $dialog).on('click', () => {
    hideModal($dialog);
  });
}

export function calculateModalBodyHeight($modal) {
  const modalFooterHeight = $('.modal-footer', $modal).outerHeight();
  const $modalBodyContent = $('.modal-body', $modal);
  const $modalBody = $('.modal-body', $modalBodyContent);
  const PADDING_FOOTER = 32 * 2;
  setModalHeight($modalBody, 'auto');

  if (modalFooterHeight) {
    const modalHeaderOuterHeight = $('.modal-header', $modal).outerHeight();

    const modalBodyOuterHeight = $modalBodyContent.outerHeight();
    const modalBodyHeight = $modalBodyContent.height();
    const modalBodyHeightDiff = modalBodyOuterHeight - modalBodyHeight;
    const windowOuterHeight = $(window).outerHeight();
    const modalHeight =
      modalHeaderOuterHeight + modalBodyOuterHeight + modalHeaderOuterHeight;
    let newModalHeight = modalBodyHeight;

    if (modalHeight > windowOuterHeight) {
      const outerHeight = windowOuterHeight - modalHeaderOuterHeight;
      newModalHeight =
        outerHeight - modalFooterHeight - modalBodyHeightDiff - PADDING_FOOTER;

      setModalHeight($modalBody, newModalHeight);
    }
  }
}

function setModalHeight($modalBody, height) {
  $modalBody.css({
    height,
    overflow: 'auto',
  });
}
